module.exports = __webpack_public_path__ + "img/box.9ad6fbdb.jpg";